export default __webpack_public_path__ + "static/media/1265.e0939f9f.png";